module.exports = __webpack_public_path__ + "static/media/location.e169cec0.png";